import React from 'react';
import { useToggle } from 'ahooks';
import { Add03 } from 'lib/lucky-x-icons-2';
import { useAppSelector } from 'store/hooks';
import { errMsg } from '../PageElement/ErrorMessage';
import AddMintWallet from '../AccountSetting/MintWallets/AddMintWallet';

interface IAddRaffleMintWalletProps {
  isRegistered?: boolean;
  vanityUrl?: string;
}

const AddRaffleMintWallet: React.FC<IAddRaffleMintWalletProps> = ({
  isRegistered = false,
  vanityUrl = '',
}) => {
  const [
    openAddWallet,
    { toggle: toggleAddWallet, setLeft: setCloseAddWallet },
  ] = useToggle();
  const { mintWalletListRaffle } = useAppSelector((state) => state.user);
  const {
    raffleInfo: { project },
  } = useAppSelector((state) => state.raffleDetails);

  return (
    <div>
      <div
        className="flex h-10 shrink-0 cursor-pointer items-center justify-center gap-2 rounded-full border border-neutral-600 px-4 hover:border-neutral-500 active:border-neutral-600 active:bg-neutral-900"
        onClick={() => {
          if (mintWalletListRaffle?.length < 25) {
            toggleAddWallet();
          } else {
            errMsg('The number of Mint wallets has reached its limit.');
          }
        }}
      >
        <Add03 size={24} />
        <div className="text-base font-medium">
          Add {isRegistered && ' Mint wallet'}
        </div>
      </div>
      <AddMintWallet
        chain={project?.blockchain || ''}
        openAddWallet={openAddWallet}
        setCloseAddWallet={setCloseAddWallet}
        isRaffle={true}
        isRegistered={isRegistered}
        vanityUrl={vanityUrl}
      />
    </div>
  );
};

export default AddRaffleMintWallet;
